import React from "react";
import { Box, Typography, Container } from "@mui/material";

const Footer: React.FC = () => {
  return (
    <Box sx={{ bgcolor: "white", py: 4, mt: 4 }}>
      <Container maxWidth="md">
        <Typography
          variant="body2"
          align="center"
          color="text.secondary"
          gutterBottom
        >
          Thank you for considering Muzkuru Memorial Services during this
          difficult time.
        </Typography>
        <Typography
          variant="body2"
          align="center"
          color="text.secondary"
          gutterBottom
        >
          We are honored to help preserve the memory of your loved one.
        </Typography>
        <Typography
          variant="body2"
          align="center"
          color="text.secondary"
          sx={{ mt: 2 }}
        >
          For questions or to confirm this booking, please contact us at
          info@muzkuru.com or call +1 (555) 123-4567
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
